<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* Global styles can go here if not handled by Tailwind */
body {
  margin: 0;
  padding: 0;
}
</style>